import { PlanServicesEnum } from 'features/incidents/components/enums'
import { useGetInventoryList } from '../api/getInventory'
import GenericInventory from './GenericInventory'
import { COVE_COLUMNS, DEFENDER_COLUMNS, EDR_COLUMNS, PATCH_COLUMNS } from './DataFile'

const DefenderInventory = () => {
  const { data: inventoryData, isLoading } = useGetInventoryList({
    type: PlanServicesEnum.WINDOWS_DEFENDER,
  })

  return (
    <GenericInventory columns={DEFENDER_COLUMNS} data={inventoryData?.data || []} isLoading={isLoading} arrayFields={[{ fieldName: 'ipAddresses', titlePrefix: 'IP Address' }]} />
  )
}

const EDRInventory = () => {
  const { data: inventoryData, isLoading } = useGetInventoryList({
    type: PlanServicesEnum.SENTINEL,
  })

  return (
    <GenericInventory
      columns={EDR_COLUMNS}
      data={inventoryData?.data || []}
      isLoading={isLoading}
      arrayFields={[{ fieldName: 'networkInterfaces', titlePrefix: 'Network Interface' }]}
    />
  )
}
const CoveInventory = () => {
  const { data: inventoryData, isLoading } = useGetInventoryList({
    type: PlanServicesEnum.COVE,
  })

  return (
    <GenericInventory
      columns={COVE_COLUMNS}
      data={inventoryData?.data || []}
      isLoading={isLoading}
      arrayFields={[{ fieldName: 'networkInterfaces', titlePrefix: 'Network Interface' }]}
    />
  )
}

export const PatchInventory = () => {
  const { data: inventoryData, isLoading } = useGetInventoryList({
    type: PlanServicesEnum.PATCH,
  })

  return <GenericInventory columns={PATCH_COLUMNS} data={inventoryData?.data || []} isLoading={isLoading} />
}
export { DefenderInventory, EDRInventory, CoveInventory }
